import IconComponent from "icons/IconComponent";

import OpenDetailsIcon from "./open-details.svg";

export default (OpenDetailsIcon as any) as IconComponent;
